import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'About DotBlack | Technology Consulting & Delivery',
      description: 'Learn how DotBlack combines consulting, implementation, innovation and skills development to help organisations move forward.',
      path: '/about-us/',
      type: 'website',
      schema: { '@context': 'https://schema.org', '@type': 'Organization', name: 'DotBlack Projex Pty (Ltd)', url: 'https://dotblack.co.za/', email: 'mufk@dotblack.co.za', telephone: '+27 11 568 5421' }
    });
  }
}
